import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c3c7343&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0c3c7343&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=0c3c7343&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3c7343",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3c7343')) {
      api.createRecord('0c3c7343', component.options)
    } else {
      api.reload('0c3c7343', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c3c7343&scoped=true", function () {
      api.rerender('0c3c7343', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/material/list/index.vue"
export default component.exports